const SUPPORTED_STEP_TYPES = new Set([
  'PERSONALITY_QUIZ',
  'LISTICLE',
  'REFERRAL',
  'LEAD_GEN',
  'TEXT_TRIVIA',
  'FILTERING',
  'COMPLETE',
  'VIDEO',
  'REVIEW',
  'STORE_FINDER',
  'PINTEREST',
  'POLL',
  'UGC_PHOTO',
  'CUSTOM_HTML',
  'GROCERY',
  'RECEIPT_VERIFICATION',
  'MEMORY_MATCH',
  'CUSTOM_JSON',
  'UGC_VIDEO',
  'GALLERY',
  'MEDIA_UPLOAD',
  'SPOT_DIFFERENCE',
  'PUZZLE',
  'DRAG_DROP',
  'BEAKER2',
  'GEN_AI_TIPS',
  'INCOMM',
  'FORM',
  'PUCK',
  'PROMO',
  'SIDE_BY_SIDE_VIDEO',
  'IMAGE_ENHANCEMENT',
  'PRODUCT_SCAN',
])

export const supportedStepType = stepType => SUPPORTED_STEP_TYPES.has(stepType)

export const getNextStep = (steps, previousStepId) => {
  if (previousStepId === 'landing') return steps[0]

  const previousIndex = steps.findIndex(step => step.id === previousStepId)
  return previousIndex >= 0 && previousIndex < steps.length - 1
    ? steps[previousIndex + 1]
    : null
}

export const initializeStepStatusArray = (brk, hasStartScreen) => {
  const statusArr = brk.steps.map((step, index) => {
    let label = step.label

    if (step.type === 'PUCK' && !label) {
      try {
        const raw = step.puck ?? step.content
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (parsed?.root?.props?.stepLabel) label = parsed.root.props.stepLabel
      } catch {}
    }

    return {
      locked: index !== 0,
      complete: false,
      scrollComplete: false,
      skipped: false,
      id: step.id,
      type: step.type,
      position: hasStartScreen ? index + 1 : index,
      label,
    }
  })

  if (hasStartScreen) {
    statusArr.unshift({
      locked: false,
      complete: false,
      scrollComplete: false,
      skipped: false,
      id: 'landing',
      type: 'LANDING',
      position: 0,
      // No label: the nav resolves it from the type, like any other entry.
      // Hardcoding 'Start' here made it look authored, so it survived translation.
      label: undefined,
    })
  }

  return statusArr
}
